const NOTES = [
  {
    title: 'Aeonm - Smooth Touch',
    text:
      'コンピの中で一番ストーリーがある曲だと思う。イントロのギターカッティングは主要モチーフではない。彼が本当に聞かせたいのは3:40から1分ほど続くパーカッシブなダンスセクションと男女のボーカルサンプルに包み込まれるアウトロセクションなんだと思う。彼がよく言う「広義のジャングル感」が感じられる。100点'
  },
  {
    title: 'blackglassG - Mr.Danceman',
    text:
      'アイデアが天才的。これを作るのは世界で彼しかいないし、作れるのも彼しかいないと思う。音像がミニマルなのにムードが柔らかい、というスタイルは彼が目指している一つの理想形だと思うのだが、そこに新たなバリエーションができた。100点'
  },
  {
    title: 'JORDAN - Gear Shimmers',
    text:
      '彼が経験してきた音楽体験みたいなものがミニマルなダウンビートで表現されている。ブレークのポップネスに大声を上げたくなるが、戻ってくる反復ビートにまた黙々と踊らされる、そんな曲。一曲を通して漂うウイスキーの匂いはさすがJORDAN。100点'
  },
  {
    title: 'Sla - 海老S',
    text:
      'なんか女の子の「結婚してください」って声が聞こえてくるな…と思っていたけど、彼が女の子から「絶交してください」って言われた声をサンプリングしているらしい。正気を疑う。元ネタ好きなんだよね。100点'
  },
  {
    title: 'ankokushinwa - Jungle Dream',
    text:
      '今回のコンピの中で一番自分のDJで使いそうな曲。スペイシーな柔らかいジャングルトラック。現行（＝90s）UKGっぽいムード。でもドロップではしっかりバンガーで掴みにくる。トレンドを押さえつつ、彼の幅広い音楽的なインプットが反映されていて、良いバランスになっている。100点'
  },
  {
    title: 'isagen - POKO',
    text:
      'ゲームミュージックのムードを醸し出すウワモノを、機能的なパーカッシブビートが支えるバランスのいい曲。サブベースの扱いや、パーカッションのパン振りなど、クラブで鳴らすと仕掛けが最大限に発揮されるようになっている。DJは一度使ってみるべき。個人的にはゲームミュージック感が増す120BPMぐらいのスクリュープレイもアリ。100点'
  },
  {
    title: 'Lo-max - Paranoia Ichijoji',
    text:
      '自分の好きな音楽をよく分析していると思う。リズムがずっとキープされていることと、ゆっくり展開するアシッドフレーズのせいか、聞いていて体感BPMが上がっていく気がした。名曲あるあるだよね。高い方のアシッドフレーズが大胆に配置されているのがルーク・バイバートっぽさを感じた。100点'
  },
  {
    title: "Craft Potters' Band - Leash Called Love",
    text:
      'Serjiの別名義。彼からこんなストレートなハウスが送られてきて、なんだかめちゃめちゃ嬉しかった。90年代後期~00年ぐらいの NYハウスがベースにあるけれど、ベースやドラムのシーケンスにプレイヤーとしての身体性が反映されていて、アシッドジャズとも違う、一癖ある気持ちいいハウストラックになっている。ドラムソロみたいなビルドアップでみんな笑顔になる。100点'
  },
  {
    title: 'Stones Taro - Soft Square',
    text:
      '自分のルーツであるイノセントな90sハウスからインスパイアされたUKGarage風のトラック。リードメロディはあの名曲のオマージュ。アッパーで踊れるドライブ感と牧歌的な明るいムードが共存するバランス感が良い。100点'
  },
  {
    title: 'in the blue shirt -Dreamin’ of you',
    text:
      'コンピの中で一番無邪気でハッピーでアリムラの音楽性をよく表した曲だと思う。サンプリングベースのシンプルなトラックなのに、いつも通りアリムラのテリトリーに落とし込まれている。こういうベースラインは踊りたくなるね。100点'
  }
]

export default NOTES



// WEBPACK FOOTER //
// ./src/const/notes.js